module.exports = __webpack_public_path__ + "img/single.733e7428.png";